export default "__VITE_ASSET__63c11371__"